(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["component__pagination-native"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('native-page-pagination')) {
    customElements.define('native-page-pagination', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.querySelector('form');
        this.input = this.querySelector('.pagination-page-input');
        if (!this.form || !this.input) return;
        this.controller = new AbortController();
        this.navigating = false;
        const { signal } = this.controller;

        this.form.addEventListener('submit', event => {
          event.preventDefault();
          this.navigate(event.submitter);
        }, { signal });
        this.input.addEventListener('change', () => this.navigate(), { signal });
        this.input.addEventListener('keydown', event => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          this.navigate();
        }, { signal });
        window.addEventListener('pageshow', () => {
          this.navigating = false;
          this.form.removeAttribute('aria-busy');
        }, { signal });
      }

      navigate(submitter) {
        if (this.navigating || submitter?.disabled) return;
        const pageParam = this.dataset.pageParam || 'page';
        const currentPage = Math.max(1, Number(this.dataset.currentPage) || 1);
        const totalPages = Math.max(1, Number(this.dataset.totalPages) || 1);
        const value = submitter?.name === pageParam ? submitter.value : this.input.value;
        const number = Number(value);
        const nextPage = value !== '' && Number.isFinite(number)
          ? Math.max(1, Math.min(totalPages, Math.floor(number)))
          : currentPage;
        this.input.value = String(nextPage);
        if (nextPage === currentPage) return;

        const url = new URL(this.form.action, window.location.href);
        url.search = window.location.search;
        url.searchParams.delete('section_id');
        url.searchParams.set(pageParam, String(nextPage));
        this.navigating = true;
        this.form.setAttribute('aria-busy', 'true');
        window.location.assign(url.href);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.navigating = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
